import React from 'react'
import { useLangContext } from '../context/lang.context'
import { s } from '../style'
import Agreement from './Agreement'

export const agreementsContent = {
  agreements: [
    {
      pl: (
        <>
          Wyrażam zgodę na wykorzystanie przez podmioty wchodzące w skład OMIDA Group <sup>[1]</sup> moich danych osobowych w celu przekazywania informacji dotyczących ofert lub promocji produktów i usług podmiotów wchodzących w skład grupy.
        </>
      ),
      en: (
        <>
          Consent for OMIDA Group<sup>[1]</sup> entities to use my personal data in order to provide information regarding offers or promotions of products and services of the entities within the group.
        </>
      ),
      groupName: 'group',
      isGroup: true,
      showFor: ['MESSAGE', 'QUOTE', 'CARRIER', 'COLLAB', 'ECOMMERCE', 'PAYMENT', 'CONTRACT', 'INTERMODAL', 'PAPERLINER', 'TRADE', 'NEWSLETTER'],
      subAgreements: [
        {
          pl: 'Zaznacz wszystkie',
          en: 'Check all',
          isCheckAll: true
        },
        {
          pl: `Zapoznałem się z <a href="https://omida-group.com/pdf/klauzula_informacyjna_dla_klientow_OG.pdf" target="_blank">klauzulą informacyjną</a> *`,
          en: 'I have read the information clause *',
          isRequired: true
        },
        {
          label: {
            pl: 'Wybierz formę kontaktu:',
            en: 'Preferred contact methods:'
          },
          options: [
            {
              pl: 'elektronicznie (np. email, SMS)',
              en: 'electronically (e.g., email, SMS)'
            },
            {
              pl: 'przez telefon',
              en: 'by phone'
            }
          ]
        }
      ]
    },
    {
      pl: 'Wyrażam zgodę na wykorzystanie moich danych osobowych w celu przekazywania informacji dotyczących ofert lub promocji produktów i usług Omida Finance Sp. z o.o.',
      en: 'Consent to use my personal data for sending information about offers or promotions of Omida Finance Sp. z o.o. products and services.',
      groupName: 'finance',
      isGroup: true,
      showFor: ['CARRIER'], // Applicable form types
      subAgreements: [
        {
          pl: 'Zaznacz wszystkie',
          en: 'Check all',
          isCheckAll: true
        },
        {
          pl: `Zapoznałem się z <a href="https://omipay.pl/ochrona-danych/" target="_blank">klauzulą informacyjną</a> *`,
          en: 'I have read the information clause *',
          isRequired: true
        },
        {
          label: {
            pl: 'Wybierz formę kontaktu:',
            en: 'Choose contact method:'
          },
          options: [
            {
              pl: 'elektronicznie (np. email, SMS)',
              en: 'electronically (e.g., email, SMS)'
            },
            {
              pl: 'przez telefon',
              en: 'by phone'
            }
          ]
        }
      ]
    }
  ]
}

const FormAgreement = ({
  formAgreements,
  setFormAgreements,
  wasSent,
  content,
  formType,
  onAgreementsChange
}) => {
  const { lang } = useLangContext()
  
  const visibleAgreements = content.agreements.filter(agreement => 
    agreement.showFor?.includes(formType)
  )

  return (
    <div css={sContainer}>
      {visibleAgreements.map((agreement, id) => (
        <Agreement
          key={id}
          text={{ __html: agreement[lang] }}
          id={id}
          formAgreements={formAgreements}
          setFormAgreements={setFormAgreements}
          required={id === 0}
          wasSent={wasSent}
          isGroup={agreement.isGroup}
          subAgreements={agreement.subAgreements}
          onAgreementsChange={onAgreementsChange}
          data={content.agreements}
          formType={formType}
        />
      ))}
    </div>
  )
}

const sContainer = {
  display: 'flex',
  flexWrap: 'wrap',
  [s.sm_down]: {
    flexDirection: 'column',
  },
  [s.xs]: {
    margin: '0',
  },
}

export default FormAgreement
